var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-title',{staticClass:"app-header-logo"},[_c('img',{attrs:{"src":"/static/img/ua_block_rgb_3.png","alt":"University of Arizona"}}),_vm._v(" Sustainability Map ")])
}
var staticRenderFns = []

export { render, staticRenderFns }